import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Stack,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import { LinkButton } from "../../../components/LinkButton";
import { PageContainer } from "../../../components/PageContainer";
import { BandBooking } from "../../../__generated__/graphql";
import dayjs from "dayjs";
import { useGetDisplayDate } from "../../../components/ZonedDateTimePicker";
interface IBandPerformances {
  bookings: BandBooking[];
  disableContainer?: boolean;
}

const BandPerformances = ({
  bookings,
  disableContainer,
}: IBandPerformances) => {
  const { getFormattedDate, getDateInFormat } = useGetDisplayDate();
  const content = (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="left">name</TableCell>
            <TableCell align="left">stage</TableCell>
            <TableCell align="left">date</TableCell>
            <TableCell align="left">actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {bookings.map((row) => {
            const editionName = row.edition?.name;
            const announcementName = row.announcement?.name;
            let displayName = editionName || announcementName || "Unknown";
            if (announcementName) {
              displayName = `${row.announcement?.edition?.name} - (announcement: ${announcementName})`;
            }
            const timezone = row.announcement?.edition?.timezone ?? row.edition?.timezone
            
            return (
              <TableRow
                key={row.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="left">{displayName}</TableCell>
                <TableCell align="left">
                  {row?.stage?.name ?? "No Stage"}
                </TableCell>
                <TableCell align="left">
                  {row.startTime &&
                    timezone &&
                    getDateInFormat(
                      row.startTime,
                      timezone,
                      "y/MM/d (cccc) HH:mm",
                    )}
                </TableCell>
                <TableCell align="left">
                  <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
                    <LinkButton path={`/booking/${row.id}`} text="View" />
                    {row.edition?.id && (
                      <LinkButton
                        path={`/edition/${row.edition.id}`}
                        text="View Edition"
                      />
                    )}
                    {row.announcement?.id && (
                      <>
                        <LinkButton
                          path={`/edition/${row.announcement.editionId}`}
                          text="View Edition"
                        />
                        <LinkButton
                          path={`/announcement/${row.announcement.id}`}
                          text="View Announcement"
                        />
                      </>
                    )}
                  </Stack>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );

  if (disableContainer) {
    return content;
  }

  return <PageContainer title="Performances">{content}</PageContainer>;
};

export default BandPerformances;
